import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import AgentOperationRequestModal from "./AgentOperationRequestModal";
import { OPERATION_REQUEST_MODES } from "./operationRequestConstants";

const OperationRequestUiContext = createContext(null);

export function useOperationRequestUi() {
  const v = useContext(OperationRequestUiContext);
  if (!v) {
    return {
      openOperationRequest: () => {},
      closeOperationRequest: () => {},
      showOperationRequestSuccess: () => {},
    };
  }
  return v;
}

/**
 * @param {{ mode?: 'operation_request' | 'payment_link' }} [options]
 */
export function OperationRequestProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [launcherMode, setLauncherMode] = useState(OPERATION_REQUEST_MODES.operation_request);
  const [successPayload, setSuccessPayload] = useState(null);

  const openOperationRequest = useCallback((options) => {
    setSuccessPayload(null);
    const mode =
      options?.mode === OPERATION_REQUEST_MODES.payment_link
        ? OPERATION_REQUEST_MODES.payment_link
        : OPERATION_REQUEST_MODES.operation_request;
    setLauncherMode(mode);
    setOpen(true);
  }, []);

  const closeOperationRequest = useCallback(() => {
    setOpen(false);
    setSuccessPayload(null);
  }, []);

  /** פותח Drawer במצב הצלחה בלבד — ללא popup Swal. */
  const showOperationRequestSuccess = useCallback((payload) => {
    setSuccessPayload(payload ?? null);
    setOpen(true);
  }, []);

  const value = useMemo(
    () => ({
      openOperationRequest,
      closeOperationRequest,
      showOperationRequestSuccess,
    }),
    [openOperationRequest, closeOperationRequest, showOperationRequestSuccess]
  );

  return (
    <OperationRequestUiContext.Provider value={value}>
      {children}
      <AgentOperationRequestModal
        open={open}
        onClose={closeOperationRequest}
        initialMode={launcherMode}
        successPayload={successPayload}
      />
    </OperationRequestUiContext.Provider>
  );
}
